// SPDX-License-Identifier: LicenseRef-Proprietary

import React from 'react';

interface HighlightableKPIProps {
  kpiId: string;
  highlightedKPI: string | null;
  onClick: (kpiId: string) => void;
  onInfoClick?: (kpiId: string) => void;
  children: React.ReactNode;
}

export const HighlightableKPI: React.FC<HighlightableKPIProps> = ({
  kpiId,
  highlightedKPI,
  onClick,
  onInfoClick,
  children,
}) => {
  const isHighlighted = highlightedKPI === kpiId;
  const isDimmed = highlightedKPI !== null && !isHighlighted;

  return (
    <div
      onClick={() => onClick(kpiId)}
      style={{
        cursor: 'pointer',
        opacity: isDimmed ? 0.3 : 1,
        transform: isHighlighted ? 'scale(1.02)' : 'scale(1)',
        transition: 'all 0.2s ease',
        position: 'relative',
      }}
    >
      {isHighlighted && (
        <div
          style={{
            position: 'absolute',
            inset: '-4px',
            borderRadius: '12px',
            border: '2px solid #3b82f6',
            pointerEvents: 'none',
            animation: 'pulse 2s ease-in-out infinite',
          }}
        />
      )}
      {children}
      {onInfoClick && (
        <button
          onClick={(e) => {
            e.stopPropagation();
            onInfoClick(kpiId);
          }}
          style={{
            position: 'absolute',
            top: '8px',
            right: '8px',
            width: '24px',
            height: '24px',
            borderRadius: '50%',
            border: '1px solid #475569',
            background: '#1e293b',
            color: '#94a3b8',
            fontSize: '14px',
            fontWeight: 'bold',
            cursor: 'pointer',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            transition: 'all 0.2s ease',
            zIndex: 10,
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.background = '#3b82f6';
            e.currentTarget.style.color = '#fff';
            e.currentTarget.style.borderColor = '#3b82f6';
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.background = '#1e293b';
            e.currentTarget.style.color = '#94a3b8';
            e.currentTarget.style.borderColor = '#475569';
          }}
          title="Click to view detailed explanation, formula, and calculation"
          aria-label="Show detailed KPI explanation"
        >
          !
        </button>
      )}
    </div>
  );
};
